import React, { Component } from 'react';
import { connect } 			from 'react-redux'
import LetterAvatar 		from './LetterAvatar';
import { withStyles } 		from 'material-ui/styles';
import Button 				from 'material-ui/Button';
import Icon 				from 'material-ui/Icon';
import Menu, { MenuItem } 	from 'material-ui/Menu';

const styles = {
  Account: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
};

class Login extends Component {
  classes = this.props.classes;
  state = {
    icon: "expand_more",
    anchorEl: null,
    open: false,
  };
  user = this.props.account ? this.props.account.user : '';

  render() {
	  const {account} = this.props
	  let first_name = account.user ? account.user.first_name : ''
	  let last_name = account.user ? account.user.last_name : ''
    return (
      <div className={this.classes.Account}>
        <Button onClick={this.handleClick}>
          <LetterAvatar name={first_name || ''}/>
            {`${first_name} ${last_name}`}
          <Icon>{this.state.icon}</Icon>
        </Button>
        <Menu
          //anchorReference={'anchorPosition'}
          anchorEl={this.state.anchorEl}
          //anchorPosition={{ top: 100, left: 200 }}
          //anchorOrigin={{ vertical: 'bottom', horizontal: 'center',}	}
          marginThreshold = {75}
          open={this.state.open}
          onClose={this.handleClose}
        >
          <MenuItem onClick={this.handleLogout}>Logout</MenuItem>
        </Menu>
      </div>
    );
  }

  handleClick = event =>{
    this.setState({icon: "expand_less", open: true, anchorEl: event.currentTarget});
  }

  handleClose = () => {
    this.setState({icon: "expand_more", open: false });
  }

  handleLogout = () => {
    this.setState({icon: "expand_more", open: false });
    this.props.logOut();
  }
}

Login = connect(
	state => ({
		account: state.account
	})
)(Login);

export default withStyles(styles)(Login);



// WEBPACK FOOTER //
// ./src/components/auth/Login.js